import { useCallback, useEffect, useRef } from 'react';

import { useHotelScope } from './scope';
import { useHotelSession } from './session';

/** Hold switching for an entire workflow, including uploads between GraphQL calls. */
export function useHotelWorkflow() {
  const scope = useHotelScope();
  const { mutationActivity } = useHotelSession();
  const controllers = useRef(new Map<AbortController, () => void>());
  useEffect(() => {
    const pending = controllers.current;
    return () => {
      pending.forEach((finish, controller) => {
        controller.abort();
        finish();
      });
    };
  }, [scope?.stateKey]);
  return useCallback(() => {
    const controller = new AbortController();
    mutationActivity(1);
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      controllers.current.delete(controller);
      mutationActivity(-1);
    };
    controllers.current.set(controller, finish);
    return {
      signal: controller.signal,
      assertActive: () => controller.signal.throwIfAborted(),
      finish,
    };
  }, [mutationActivity]);
}
